angular.module('property-deal')
    .component('propertyDealList', {
        bindings: {
            statistics: '<',
            filters: '<',
            page: '<'
        },
        templateUrl: 'app/property-deal/list.html',
        controller: function ($scope, $state, $stateParams, $httpParamSerializer, LeadService, PropertyService, PropertyDealService, PropertyDeal) {
            this.reset = () => this.filters = {};
            this.LeadService = LeadService;
            this.PropertyService = PropertyService;
            this.PropertyDealService = PropertyDealService;

            this.$onInit = () => {
                this.statuses = PropertyDeal.statuses()
                this.agreementTypes = ['PRE_BOOKING', 'RESERVATION', 'DEVELOPMENT', 'PRELIMINARY_SALE', 'CONDITIONAL_SALE', 'HANDOVER',
                    'CONDITIONAL_SALE_BEFORE_OWNERSHIP_TRANSFER', 'OWNERSHIP_TRANSFER', 'CANCELLATION']
            }

            this.isDateBeforeToday = (date) => {
                return new Date(date) < new Date(new Date().toDateString());
            }

            this.getExportUrl = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/property-deal-export?" + $httpParamSerializer(paramsAll)
            }
            this.getExportPaymentsUrl = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/property-deal-export/payments?" + $httpParamSerializer(paramsAll)
            }

            this.noBankAccount = item => {
                return item.items.some(it => it.bankAccount == null)
            }
            this.noLivingAreaFinal = item => {
                return item.items.filter(it => it.type === 'ASSET' && it.property.livingArea != null).some(it => it.property.livingAreaFinal == null)
            }

            $scope.$on('property-deal.updated', () => $state.reload());
        }
    })
